import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ChevronLeft from '../Icons/ChevronLeft';
import Close from '../Icons/Close';
import { rtl } from '../../../utils/language';
import { mediaQueries } from '../MediaQueries/mediaQueries';
import { getCodeFromSubjectCategory } from './helpers';

const LayoutWrapper = styled.div`
  width: calc(100% + 48px);
  height: calc(100% - 50px);
  background-image: ${props =>
    props.displaySubjectColor
      ? `var(--${props.subjectCode}-gradient)`
      : 'unset'};
  background-repeat: no-repeat;
  background-size: 100% 220px;
  padding-bottom: 42px;
  position: relative;
  ${({ isStudentJourney }) =>
    isStudentJourney
      ? ``
      : `margin-top: -18px;
  margin-left: -24px;`};
`;

const Header = styled.div`
  color: var(--white);
  padding: 48px 16px 0;

  ${mediaQueries('screen-medium', 'min')`
      padding: 24px 45px 0;
  `};

  display: flex;
  justify-content: center;
  align-items: center;
`;

const BackButton = styled.div`
  cursor: pointer;
  font-family: var(--font-family-opensans);
  font-size: 16px;
  font-weight: 700;
  color: var(--white);
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: fit-content;

  svg {
    margin-right: 10px;
  }

  ${rtl`
    font-family: Tajawal;
  `};
`;

const Title = styled.div`
  letter-spacing: normal;
  text-align: center;
  color: var(--white);
  font-weight: 700;
  flex-grow: 1;

  ${mediaQueries('screen-small', 'min')`
      font-size: 24px;
  `};

  ${rtl`
    font-family: Tajawal;
  `};
`;

const ContentWrapper = styled.div`
  min-height: 100%;
  height: fit-content;
  width: 100%;
  padding: 24px 24px 0;

  ${mediaQueries('screen-medium', 'min')`
      padding: 40px 24px 0;
  `};
`;

const icons = {
  ChevronLeft: {
    component: ChevronLeft,
    size: 12,
  },
  Close: {
    component: Close,
    size: 28,
  },
};

const Layout = ({
  backButtonText,
  title,
  children,
  subjectCategory,
  onGoBack,
  displayHeader,
  displaySubjectColor,
  icon,
  isStudentJourney,
}) => {
  const iconData = icons[icon];
  const { i18n } = useTranslation();

  return (
    <LayoutWrapper
      data-testid="assignment-layout-header"
      subjectCode={getCodeFromSubjectCategory(subjectCategory)}
      displaySubjectColor={displaySubjectColor}
      dir={i18n.dir()}
      isStudentJourney={isStudentJourney}
    >
      {displayHeader && (
        <Header dir="ltr">
          {onGoBack && (
            <BackButton data-testid="backButton" onClick={onGoBack}>
              <iconData.component size={iconData.size} />
              {backButtonText}
            </BackButton>
          )}
          <Title>{title}</Title>
        </Header>
      )}
      <ContentWrapper>{children}</ContentWrapper>
    </LayoutWrapper>
  );
};

Layout.defaultProps = {
  icon: 'ChevronLeft',
  subjectCategory: 'Default',
  displayHeader: true,
  displaySubjectColor: true,
  isStudentJourney: false,
};

Layout.propTypes = {
  children: PropTypes.any.isRequired,
  backButtonText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subjectCategory: PropTypes.string,
  onGoBack: PropTypes.func.isRequired,
  displayHeader: PropTypes.bool,
  displaySubjectColor: PropTypes.bool,
  icon: PropTypes.string,
  isStudentJourney: PropTypes.bool,
};
export default Layout;
